export class TimeFrame {
    'startTime';
    'endTime';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "startTime",
            "baseName": "startTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "endTime",
            "baseName": "endTime",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return TimeFrame.attributeTypeMap;
    }
    constructor() {
    }
}
